import { render } from "./SocietyPage.vue?vue&type=template&id=f79ce114&scoped=true"
import script from "./SocietyPage.vue?vue&type=script&lang=js"
export * from "./SocietyPage.vue?vue&type=script&lang=js"

import "./SocietyPage.vue?vue&type=style&index=0&id=f79ce114&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f79ce114"]])

export default __exports__